export interface SubscriptionStateResponse {
  subscriptionId: string;
  friendlySubscriptionId: string;
  tenantId: string;
  controllerId: string;
  state: string;
  country: string;
  paymentMethodId: string;
  pendingChanges?: true;
  createdAt: string;
  updatedAt: string;
  entities: Entity[];
}

export interface UserSubscriptions {
  version: string;
  totalCount: number;
  maxPaginationLimit: number;
  defaultPaginationLimit: number;
  contents: SubscriptionStateResponse[];
  links: Link[];
}

export interface Entity {
  entityId: string;
  subscriptionId: string;
  userId: string;
  shippingAddressId: string;
  state: string;
  entityType: string;
  entityStartDate: string;
  entityEndDate?: string;
  linkedEntities: LinkedEntity[];
  commerce: Commerce;
  product: Product;
  source: Source;
  fulfillment: Fulfillment;
  entityDetails: EntityDetails;
  createdAt: string;
  updatedAt: string;
}

export interface Commerce {
  type: string;
  value: CommerceValue;
}

export interface CommerceValue {
  subscriptionId: string;
  friendlySubscriptionId: string;
}

export interface EntityDetails {
  accessoryId: string;
  pendingAssociationId: string;
  pendingAssociationState: string;
  serialNumber: string;
  uniqueDeviceId: string;
  ledgerResourceId: string;
}

export interface Fulfillment {
  type: string;
  value: FulfillmentValue;
}

export interface FulfillmentValue {
  lccSubscriptionId?: string;
  fulfillmentOrderId: string;
  obId?: string;
  threePoController?: string;
  shippedDate?: string;
}

export interface LinkedEntity {
  type: string;
  value: string;
}

export interface Product {
  type: string;
  value: ProductValue;
}

export interface ProductValue {
  productSku: string;
  productType: string;
  parentProductSku: string;
}

export interface Source {
  type: string;
  value: SourceValue;
}

export interface SourceValue {
  orderId: string;
  itemId: string;
  parentItemId: string;
}

export interface Link {
  rel: string;
  href: string;
}

export enum SubscriptionStateEnum {
  SUBSCRIBED = 'active',
  CANCELED = 'inactive',
  CANCELING = 'deactivating',
  PAUSED = 'paused',
  PENDING = 'pending',
  UPDATING = 'updating',
  DELINQUENT = 'delinquent',
  SUSPENDED = 'suspended'
}

export enum SubscriptionEntityTypeEnum {
  PRINTER = 'iot-printer',
  INSTANT_INK = 'instant-ink',
  PAPER = 'instant-paper'
}

export enum PRODUCT_TYPES {
  INSTANT_PAPER = 'instantPaper',
  INSTANT_INK = 'instantInk',
  LEASE_RECEIVABLE = 'leaseReceivable',
  PRINTER = 'printer',
  LEASE_PRICE_TYPE = 'planChange',
  CAREPACK = 'carepack'
}

export enum PLAN_OPTIONS {
  AVAILABLE = 'available',
  UPGRADE_ONLY = 'upgrade-only',
  UNAVAILABLE = 'unavailable'
}

export interface Subscription {
  edit: {
    enabled: boolean;
    locked: boolean;
    optionId: string;
  };
}
export interface SubscriptionOptionsResponse {
  subscription: Subscription;
  entities: Entity[];
}
